// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_16kuEtjnoTj0tabwDDgVWs","label":"_263eCPp_2vZ9yrjlFT0IEE","row":"CLMX_zL9zD96sVd3N7l9X","textarea":"_29Z42cP1KcIgYGlpbYx7Ih","med-nonmed":"_1edmyLZDGYQJsR-lBssKI4","medNonmed":"_1edmyLZDGYQJsR-lBssKI4"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Survey/Panel/styles.scss
 ** module id = 513
 ** module chunks = 0
 **/